<script lang="ts">
import { defineComponent, inject } from 'vue'
import LogoBizHint from '@/components/logo/LogoBizHintDefault.vue'
import CopyrightDefault from '@/components/_core/CopyrightDefault.vue'
import {
  staticPagesTermsPath,
  staticPagesPrivacyPath,
} from '@/generated/railsRoutes'

export default defineComponent({
  name: 'FooterLP',

  components: {
    LogoBizHint,
    CopyrightDefault,
  },

  setup() {
    // constants
    const EXTERNAL_URL = inject<Record<string, string>>('EXTERNAL_URL')

    const footerNavigationItems = [
      {
        label: '利用規約',
        to: staticPagesTermsPath(),
      },
      {
        label: 'プライバシーポリシー',
        to: staticPagesPrivacyPath(),
      },
      {
        label: '運営会社',
        to: EXTERNAL_URL!.bizhint_corporate_url,
      },
    ] as const

    return {
      // constants
      footerNavigationItems,
    }
  },
})
</script>

<template>
  <footer
    ref="footer"
    class="footer">
    <section class="f-section__footer">
      <div class="f-section__footer--body">
        <section class="f-section__footerNavigation">
          <div class="f-section__footerNavigation--body">
            <div class="o-list__footerNavigation">
              <ul class="o-list__footerNavigation--items">
                <li
                  v-for="item in footerNavigationItems"
                  :key="item.label"
                  class="o-list__footerNavigation--item">
                  <a
                    class="a u-action__black u-text__small"
                    :href="item.to">
                    {{ item.label }}
                  </a>
                </li>
              </ul>
            <!-- /.o-list__footerNavigation --></div>
          <!-- /.f-section__footerNavigation body --></div>
        <!-- /.f-section__footerNavigation --></section>

        <section class="f-section__copyright">
          <div class="f-section__copyright--body">
            <CopyrightDefault alignment="center">
              記載されている会社名および商品・サービス名（ロゴマーク等を含む）は、各社の商標または各権利者の登録商標です。<br>
              All company names, product and service names, and logos are trademarks or registered trademarks of their respective owners.
            </CopyrightDefault>
          <!-- /.f-section__copyright body --></div>
        <!-- /.f-section__copyright --></section>

        <section class="f-section__logo">
          <div class="f-section__logo--body">
            <LogoBizHint :has-link="false" />
          <!-- /.f-section__logo body --></div>
        <!-- /.f-section__logo --></section>
      <!-- /.f-section__footer body --></div>
    <!-- /.f-section__footer --></section>
  </footer>
</template>

<style lang="sass" scoped>
// foundation
.f-section__footer
  padding: 2em #{$global-prop-pc}px
  background-color: rgba($bg-white, 1)

  +breakpoint
    padding: 2em #{$global-prop-sp}px

.f-section__copyright
  margin-top: 2em

  &:first-child
    margin-top: 0

  +breakpoint
    margin-top: 1.5em

.f-section__logo
  $root: &
  margin-top: 2em

  &:first-child
    margin-top: 0

  & &--body
    max-width: 150px
    margin: 0 auto

  +breakpoint
    #{$root}--body
      margin-left: 0

.o-list__footerNavigation
  $root: &

  & &--items
    display: flex
    align-items: center
    justify-content: center

  & &--item
    margin-left: 2em

    &:first-child
      margin-left: 0

  +breakpoint
    #{$root}--items
      display: block

    #{$root}--item
      margin:
        top: 0.5em
        left: 0

      &:first-child
        margin-top: 0
</style>
